import React from 'react'
import styles from '../../styles/modules/components/SelfServe/selfserve-modal.module.scss';
import UIModal from '../common/ui-components/surface/UIModal';
import { useState } from 'react';
import Image from '../common/Image'
import { getStaticPath, openDialer } from '../../utils';
import { QueryForm } from './QueryForm';
import { Hidden } from '@mui/material';
import { getPageURL } from '../../utils/tracking';
import { chatbotClicked } from '../../tracking/segment/footer';
import { CUSTOMER_CARE_NUMBER } from '../../constants';

interface MainProps{
    closeModal: any,
    subIssues: any,
    is_open: boolean,
}

export const ContactUs = (props: MainProps) => {
    const [writeToUs, setWriteToUs] = useState<Boolean>(false);
    const close = () => {
        // changeOpen(false);
        props.closeModal(false);
        setWriteToUs(false);
        return false
    }
    const openChat = () => {
        // event.preventDefault()
        // changeOpen(false)
        props.closeModal(false);
        chatbotClicked({...getPageURL()})
        window.open(`https://onst.in/4dCuJA`, "noopener,noreferrer")
        window.opener = null
    }


    return (
        <UIModal isOpen={props.is_open} onClick={close} boxClass={styles.apply_box} larger={!writeToUs ? true : false}>
            {!writeToUs &&

                <div className={styles.contact_us}>
                    <div className={styles.contact_us__card} onClick={() => setWriteToUs(true)}>
                        <Image
                            src={getStaticPath(`/static/images/selfserve/write_us.png`)}
                            width="60"
                            height="60"
                            alt="Write to Us"
                            unoptimized={true}
                        />
                        <h5>Write to Us</h5>
                        <p>Our Executives will respond to your queries shortly</p>
                    </div>
                    <div className={styles.contact_us__card} onClick={openChat}>
                        <Image
                            src={getStaticPath(`/static/images/selfserve/chat.png`)}
                            width="60"
                            height="60"
                            alt="Write to Us"
                            unoptimized={true}
                        />
                        <h5>Chat</h5>
                        <p>Our Virtual Assistants and Agents are always available to help you.</p>
                    </div>
                    <Hidden key='web' mdDown>
                        {/* This section will not show for mobiles */}
                        <div className={styles.contact_us__card} onClick={() => {}}>
                            <Image
                                src={getStaticPath(`/static/images/selfserve/call.png`)}
                                width="60"
                                height="60"
                                alt="Write to Us"
                                unoptimized={true}
                            />
                            <h5>Talk</h5>
                            {/* <p>Call us <a className={styles.mobile_number} href="tel:9920599206">9920599206</a> Toll Free Number Working hours: 9:00 AM to 7:00 PM</p> */}
                            <p>Call us {CUSTOMER_CARE_NUMBER} Toll Free Number Working hours: 9:00 AM to 7:00 PM</p>
                        </div>
                    </Hidden>
                    <Hidden key='mobile'  mdUp>
                        {/* This section only show for mobile devices */}
                        <div className={styles.contact_us__card} onClick={() => openDialer(CUSTOMER_CARE_NUMBER)}>
                            <Image
                                src={getStaticPath(`/static/images/selfserve/call.png`)}
                                width="60"
                                height="60"
                                alt="Write to Us"
                                unoptimized={true}
                            />
                            <h5>Talk</h5>
                            {/* <p>Call us <a className={styles.mobile_number} href="tel:9920599206">9920599206</a> Toll Free Number Working hours: 9:00 AM to 7:00 PM</p> */}
                            <p>Call us on Onsitego Toll Free Number Working hours 9:00 AM to 7:00PM</p>
                        </div>
                    </Hidden>
                </div>
            }
            {writeToUs &&

                <QueryForm onClose={close} subIssues={props.subIssues} />
            }
        </UIModal>
    );
}
